import type { CareerUpConfirmationStep } from './careerUpConfirmationTypes';

export function stepQuestionKey(stepId: CareerUpConfirmationStep): string {
  return `submitDocuments.careerUpConfirmation.steps.${stepId}`;
}

export function stepFootnoteKey(stepId: CareerUpConfirmationStep): string | null {
  if (stepId === 'cardPassword') {
    return 'submitDocuments.careerUpConfirmation.passwordFootnote';
  }
  return null;
}

export function uploadPromptKey(stepId: 'careerUpCardUploaded' | 'driversLicenseUploaded'): string {
  return `submitDocuments.careerUpConfirmation.${stepId}NeededMessage`;
}
